import { ReactComponent as Icon } from "../images/success.svg";

const SuccessIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default SuccessIcon;
